<div class="form-group">
  <div class="quantity-select-container">
    <div class="quantity-field" role="group" aria-label="Quantity selector">
      <!-- Decrement Button -->
      <button
        class="btn number-input-decrement-button py-0 px-1"
        type="button"
        (click)="decrement()"
        [disabled]="innerValue <= minValue || isDisabled"
        [attr.aria-disabled]="innerValue <= minValue || isDisabled"
        attr.aria-label="{{ 'number.input.decrease.screenreader' | translate }}"
      >
        <span
          class="material-icons material-symbols-outlined d-flex justify-content-center align-items-center"
          aria-hidden="true"
        >
          remove
        </span>
      </button>
      <!-- Input Field -->
      <input
        id="quantityInput"
        type="number"
        [(ngModel)]="innerValue"
        (keydown)="onNumberKeydown($event)"
        class="form-control bid-amount-input text-center"
        [attr.min]="minValue"
        [attr.max]="maxValue !== -1 ? maxValue : null"
        [disabled]="isDisabled"
        [attr.aria-disabled]="isDisabled || null"
        [attr.aria-valuemin]="minValue"
        [attr.aria-valuemax]="maxValue !== -1 ? maxValue : null"
        [attr.aria-valuenow]="innerValue"
        aria-label="Quantity"
        #input
      />

      <!-- Increment Button -->
      <button
        class="btn number-input-increment-button py-0 px-1"
        type="button"
        (click)="increment()"
        [disabled]="(maxValue !== -1 && innerValue >= maxValue) || isDisabled"
        [attr.aria-disabled]="(maxValue !== -1 && innerValue >= maxValue) || isDisabled"
        attr.aria-label="{{ 'number.input.increase.screenreader' | translate }}"
      >
        <span
          class="material-icons material-symbols-outlined d-flex justify-content-center align-items-center"
          aria-hidden="true"
        >
          add
        </span>
      </button>
    </div>
  </div>
</div>
